import React from 'react'

function News() {
  return (
    <div className="h-screen flex items-center justify-center bg-black">
      <h1 className="font-bold text-4xl text-white px-6 py-3">News page</h1>
    </div>
  )
}

export default News
